// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leadership-first{
    display: flex;
    justify-content: space-between;
    
}
.boxes-team{
    width: max-content;
    display: flex;
    max-width:400px;
    margin-top: 3vw;
    min-height: 500px;
    background: white;
    border-radius: 30px;
    margin-bottom: 6vw;
    
    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);
    position: relative;
   
}
@media (max-width:'450px'){
    .boxes-team{
        height: 250px;
    }  
}
.slider-box{
    width:'100px';
    display:flex;
    height:max-content;

    /* overflow-y: scroll; */
}

.the-card-main{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    transform-style: preserve-3d;
    transition: transform 0.5s ease;
}
.the-card-main:hover{
    transform: rotateY(180deg);
}
.team-front{
    position: absolute;
    width: 100%;
    height: 80%;
    overflow: clip;
    margin-top: 30px;
    /* margin-bottom: 30px; */
    
    backface-visibility: hidden;
    background-color: white;

}
.team-back{
    overflow-y: scroll;
    /* overflow-y: visible; */
    position: absolute;
    width: 100%;
    height: 80%;
    padding-top: 30px;
    margin-top: 30px;
    /* margin-bottom: 30px; */
    backface-visibility: hidden;
    background-color: white;
    transform: rotateY(180deg);
    display: flex;
    justify-content: center;
    align-items: start;
  
}

.slick-slide > div{
    margin: 0 10px;
}

.p-pad{
    /* padding-top:100px; */
    /* margin-top:30px; */
   margin-left: 15px;
   margin-right: 15px;
   top:0px;
}
.leadershipwidth{
    width:50%
}
@media(max-width:750px){
    .leadershipwidth{
        width:100%
    }
}`, "",{"version":3,"sources":["webpack://./src/Aboutus.js/Leadership.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;;AAElC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;;IAElB,gDAAgD;IAChD,kBAAkB;;AAEtB;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;;IAElB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,yBAAyB;;IAEzB,2BAA2B;IAC3B,uBAAuB;;AAE3B;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;GACtB,iBAAiB;GACjB,kBAAkB;GAClB,OAAO;AACV;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ","sourcesContent":[".leadership-first{\n    display: flex;\n    justify-content: space-between;\n    \n}\n.boxes-team{\n    width: max-content;\n    display: flex;\n    max-width:400px;\n    margin-top: 3vw;\n    min-height: 500px;\n    background: white;\n    border-radius: 30px;\n    margin-bottom: 6vw;\n    \n    box-shadow: 0px 1px 10px 4px rgba(0, 0, 0, 0.06);\n    position: relative;\n   \n}\n@media (max-width:'450px'){\n    .boxes-team{\n        height: 250px;\n    }  \n}\n.slider-box{\n    width:'100px';\n    display:flex;\n    height:max-content;\n\n    /* overflow-y: scroll; */\n}\n\n.the-card-main{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    transform-style: preserve-3d;\n    transition: transform 0.5s ease;\n}\n.the-card-main:hover{\n    transform: rotateY(180deg);\n}\n.team-front{\n    position: absolute;\n    width: 100%;\n    height: 80%;\n    overflow: clip;\n    margin-top: 30px;\n    /* margin-bottom: 30px; */\n    \n    backface-visibility: hidden;\n    background-color: white;\n\n}\n.team-back{\n    overflow-y: scroll;\n    /* overflow-y: visible; */\n    position: absolute;\n    width: 100%;\n    height: 80%;\n    padding-top: 30px;\n    margin-top: 30px;\n    /* margin-bottom: 30px; */\n    backface-visibility: hidden;\n    background-color: white;\n    transform: rotateY(180deg);\n    display: flex;\n    justify-content: center;\n    align-items: start;\n  \n}\n\n.slick-slide > div{\n    margin: 0 10px;\n}\n\n.p-pad{\n    /* padding-top:100px; */\n    /* margin-top:30px; */\n   margin-left: 15px;\n   margin-right: 15px;\n   top:0px;\n}\n.leadershipwidth{\n    width:50%\n}\n@media(max-width:750px){\n    .leadershipwidth{\n        width:100%\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
